/**
 * Canonical Catchball URLs — one surface for hold / pass / fork / sessions / send.
 * See docs/9-exploration/CATCHBALL-BALL-DESK.md
 */

export function buildCatchballInboxUrl(
  cycleId: string,
  loopId: string,
  opts?: { ballId?: string | null },
): string {
  const base = `/prioritization/cascade/catchball/${encodeURIComponent(cycleId)}/${encodeURIComponent(loopId)}`;
  if (opts?.ballId) {
    return `${base}?ballId=${encodeURIComponent(opts.ballId)}`;
  }
  return base;
}

/** Compose / first toss — only when the loop is still drafting (or not created yet). */
export function buildSendTheBallComposeUrl(
  cycleId: string,
  trackId: string,
  opts?: { fromDesigner?: boolean },
): string {
  const params = new URLSearchParams();
  params.set('trackId', trackId);
  if (opts?.fromDesigner) params.set('from', 'designer');
  return `/prioritization/cascade/compose/${encodeURIComponent(cycleId)}?${params.toString()}`;
}

/**
 * True when the loop has already left drafting — further movement (pass up/down)
 * belongs on Catchball, not Request Composer.
 */
export function isLoopPastFirstSend(loopState: string | null | undefined): boolean {
  if (!loopState || loopState === 'drafting') return false;
  if (loopState === 'closed' || loopState === 'CLOSED' || loopState === 'DECLINED') {
    return false;
  }
  return true;
}

/**
 * "Toss the ball" from a track:
 * - drafting / no live loop → Request Composer (first toss)
 * - already in flight → Catchball (pass any direction)
 */
export function resolveSendTheBallHref(
  cycleId: string,
  trackId: string,
  loop: { id: string; state: string } | null | undefined,
  opts?: { fromDesigner?: boolean },
): { href: string; mode: 'compose' | 'inbox' } {
  if (loop && isLoopPastFirstSend(loop.state)) {
    return { href: buildCatchballInboxUrl(cycleId, loop.id), mode: 'inbox' };
  }
  return {
    href: buildSendTheBallComposeUrl(cycleId, trackId, opts),
    mode: 'compose',
  };
}
